import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

export const SimQuickMove = ({ dealer, meId, onClose, onDone }) => {
  const [dir, setDir] = useState("give");
  const [qty, setQty] = useState(10);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/sim-stock/move", dir === "give" ? { from_id: meId, to_id: dealer.id, qty: Number(qty), note: "" } : { from_id: dealer.id, to_id: meId, qty: Number(qty), note: "" });
      toast.success(dir === "give" ? `${qty} SIM assegnate a ${dealer.name}` : `${qty} SIM riprese da ${dealer.name}`);
      window.dispatchEvent(new Event("sim-changed")); onDone?.(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Spostamento non riuscito"); }
    finally { setBusy(false); }
  };
  return <Dialog open={!!dealer} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="sim-quick-move-dialog">
      <DialogHeader><DialogTitle>Sposta SIM · {dealer?.name}</DialogTitle></DialogHeader>
      <p className="text-sm text-muted-foreground">Il dealer ha {dealer?.sim_stock ?? 0} SIM Italia Mobile.</p>
      <div className="grid grid-cols-2 gap-2">
        <Button variant={dir === "give" ? "default" : "outline"} className="gap-2" onClick={() => setDir("give")} data-testid="sim-quick-give"><ArrowUpRight className="w-4 h-4" />Dai SIM al dealer</Button>
        <Button variant={dir === "take" ? "default" : "outline"} className="gap-2" onClick={() => setDir("take")} data-testid="sim-quick-take"><ArrowDownLeft className="w-4 h-4" />Riprendi SIM</Button>
      </div>
      <Input type="number" min="1" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="sim-quick-qty" />
      <Button disabled={busy || !(Number(qty) >= 1)} onClick={submit} data-testid="sim-quick-submit">{busy ? "Spostamento…" : `Sposta ${qty} SIM`}</Button>
    </DialogContent>
  </Dialog>;
};
